var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconParkHandRight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-park:hand-left"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11 10.25V4.75H9.5V10.25H11Z",
    fill: "#2F88FF",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.5 4.74981C7.7237 3.10736 6.69392 2.16565 6.4107 1.92471C5.98582 1.5633 5.50565 1.71506 5.50565 2.61951C5.50565 3.52396 6.8216 4.06083 6.8216 4.74981C6.82245 4.75391 5.13225 4.75418 1.75101 4.75063C1.33667 4.75018 1.00044 5.08571 1 5.50006V5.50083C1 5.91563 1.33625 6.25188 1.75104 6.25188H3.50412C3.80585 8.24403 3.97232 9.32728 4.0036 9.50163C4.05047 9.76316 4.29975 10.2498 5.017 10.2498C5.49517 10.2498 6.98952 10.2498 9.5 10.2498V4.74981Z",
    fill: "#EAC033"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconParkHandRight);
export default __webpack_public_path__ + "static/media/icon-park_hand-right.7a9bdeff1bfe10fc6d1f855a88b93a37.svg";
export { ForwardRef as ReactComponent };